var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role"},[_vm._v(" "+_vm._s(_vm.$t(("users.backend.role." + _vm.role)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }